import { Details } from '../../components/Details/Details';
import { create } from '../../utils/create';
import { isEqual } from '../../utils/objects';
export class PageDetails {
    constructor(parent, model, controller, go, header) {
        this.createDefaultLayer = () => {
            this.section = create({
                tagName: 'section',
                classNames: 'details',
                parent: this.parent
            });
        };
        this.unmount = () => {
            var _a;
            (_a = this.section) === null || _a === void 0 ? void 0 : _a.remove();
        };
        this.mount = (props) => {
            if (this.header.searchWrapper !== null) {
                this.header.searchWrapper.style.visibility = 'hidden';
            }
            this.createDefaultLayer();
            const state = this.model.getState();
            const product = state.products.find((item) => { var _a; return item.id === ((_a = props === null || props === void 0 ? void 0 : props.params) === null || _a === void 0 ? void 0 : _a.productId); });
            const details = new Details(this.section, this.go, this.controller, this.header);
            if (product) {
                details.update({ item: product });
            }
            this.model.subscribe((state, prevState) => {
                if (isEqual(state.products, prevState === null || prevState === void 0 ? void 0 : prevState.products)) {
                    return;
                }
                const items = [...new Set(state.products.map((item) => item).filter((item) => !!item))];
                details.update({
                    item: items.find((item) => { var _a; return item.id === ((_a = props === null || props === void 0 ? void 0 : props.params) === null || _a === void 0 ? void 0 : _a.productId); }) || items[0]
                });
            });
            (props === null || props === void 0 ? void 0 : props.mounted) && (props === null || props === void 0 ? void 0 : props.mounted());
        };
        this.parent = parent;
        this.section = null;
        this.model = model;
        this.go = go;
        this.controller = controller;
        this.header = header;
    }
}
